const { name, version, isChromiumEdge } = require('./env');

module.exports =
  ((isChromiumEdge) || (name === 'Chrome' && version >= 72) ||
  (name === 'Firefox' && version >= 66) || (name === 'Opera' && version >= 60));
